export default ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://enterpriseblog.rosettastone.com/",
        external: true,
        new_window: true,

        // Labels
        label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
        visible: true,
        destination: "/ressources/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
        visible: false,
        destination: "/solutions/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_secondary_label
    }
});
